import React, { memo } from 'react';

import { Person, PersonOutline, Close } from '@material-ui/icons';

import { func, bool, array, string } from 'prop-types';
import { generate } from 'shortid';

import HeaderDrawerCategory from './HeaderDrawerCategory';
import { Container, HeaderDrawer, ButtonIcon, HeaderTextContainer, MenuContainer } from './styles';

// DEIXAR O IDX COMO KEY, MESMO COM O WARNING DO ESLINT
// O GENERATE DO SHORTID NÃO GERA O EFEITO DO COLLAPSE
const HeaderDrawerMenu = ({ open, onClose, menu, customerName }) => (
  <Container open={open} onClose={onClose} anchor="left">
    <HeaderDrawer>
      {customerName && <Person />}
      {!customerName && <PersonOutline />}
      <HeaderTextContainer>
        {customerName ? (
          `Olá ${customerName}`
        ) : (
          <>
            <a href="/cliente/login" title="Entrar">
              Entre
            </a>
            ou
            <a href="/cliente/cadastro" title="Cadastrar">
              Cadastre-se
            </a>
          </>
        )}
      </HeaderTextContainer>
      <ButtonIcon title="Fechar" onClick={onClose}>
        <Close />
      </ButtonIcon>
    </HeaderDrawer>
    <MenuContainer>{menu && menu.map((cat) => <HeaderDrawerCategory category={cat} key={generate()} />)}</MenuContainer>
  </Container>
);

HeaderDrawerMenu.propTypes = {
  open: bool,
  onClose: func,
  menu: array,
  customerName: string,
};

export default memo(HeaderDrawerMenu);
